import api from './api';

export async function uploadImageToCloudinary(file) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', 'products_preset');

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/dpnsfwqpm/image/upload`,
    {
      method: 'POST',
      body: formData,
    }
  );

  const data = await res.json();

  if (!res.ok) {
    console.error('Cloudinary upload error:', data);
    throw new Error(data.error?.message || 'Cloudinary upload failed');
  }

  return data.secure_url;
}

export async function uploadMultipleImagesToCloudinary(files) {
  const uploadPromises = Array.from(files).map(file => uploadImageToCloudinary(file));
  return Promise.all(uploadPromises);
}



export const productService = {
  async getAllProducts() {
    const response = await api.get('/products');
    return response.data;
  },

  async getProductById(id) {
    const response = await api.get(`/products/${id}`);
    return response.data;
  },

  async updateProduct(id, productData) {
  let imageUrls = productData.imageUrls || [];

  // Si hay nuevas imágenes, subirlas a Cloudinary
  if (productData.images && productData.images.length > 0) {
    const newImageUrls = await uploadMultipleImagesToCloudinary(productData.images);
    imageUrls = [...imageUrls, ...newImageUrls];
  }

  // Mantener compatibilidad con imagen única
  let image = productData.image;
  if (productData.image && typeof productData.image !== 'string') {
    image = await uploadImageToCloudinary(productData.image);
  }

  const payload = {
    ...productData,
    image,
    imageUrls,
  };

  const response = await api.patch(`/products/${id}`, payload);
  return response.data;
}
,

  async createProduct(productData) {
    let image;
    let imageUrls = [];

    // Subir imagen principal (compatibilidad)
    if (productData.image) {
      image = await uploadImageToCloudinary(productData.image);
    }

    // Subir múltiples imágenes
    if (productData.images && productData.images.length > 0) {
      imageUrls = await uploadMultipleImagesToCloudinary(productData.images);
    }

    const payload = {
      ...productData,
      image,
      imageUrls,
    };

    const response = await api.post('/products', payload);
    return response.data;
  },


  async deleteProduct(id) {
    const response = await api.delete(`/products/${id}`);
    return response.data;
  },

  async searchProducts(query) {
    const response = await api.get(`/products/search?q=${encodeURIComponent(query)}`);
    return response.data;
  },

  async getProductsByCategory(categoryId) {
    const response = await api.get(`/products/category/${categoryId}`);
    return response.data;
  }
};